import { useTranslation } from 'react-i18next';
import SiteNavbar from '@/components/feature/SiteNavbar';
import SiteFooter from '@/components/feature/SiteFooter';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroBlock from './components/HeroBlock';
import FeaturesBlock from './components/FeaturesBlock';

export default function DefterKasaPage() {
  const { t } = useTranslation();
  const links = [
    { label: 'nav.home',        href: '/',        isRoute: true },
    { label: 'nav.apps',        href: '/apps',    isRoute: true },
    { label: 'nav.games',       href: '/games',   isRoute: true },
    { label: 'nav.notify',      href: '/?contactProduct=defter-kasa#contact', isRoute: true },
    { label: 'dk.nav.download', href: 'https://play.google.com/store/apps/details?id=com.companyname.kucukesnafcari&pcampaignid=web_share' },
  ];

  return (
    <div className="min-h-screen bg-[#070b12]">
      <SiteNavbar links={links} sectionAware={false} />
      <HeroBlock />
      <div id="features">
        <FeaturesBlock />
      </div>
      <SiteFooter />
      <ScrollToTop />
    </div>
  );
}
